import styled from "@emotion/styled"

const ListTwoCardHeader = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  gap: 20px;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    margin-bottom: 10px;
    align-items: flex-start;
    text-align: left;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    margin-bottom: 34px;
  }
`

export default ListTwoCardHeader
